<template>
  <div class="home">
    <el-container>
      <!-- 头部区域 -->
      <el-header height="80px">
        <div class="title">{{baseName}}数据中心平台</div>
        <div class="menu">
          <el-button type="primary" size="small" @click="editInfo">修改个人信息</el-button>
          <el-button type="danger" size="small" @click="pwDialogVisible = true">修改密码</el-button>
          <el-button type="warning" size="small" @click="logout">退出登录</el-button>
        </div>
      </el-header>
      <el-container>
        <!-- 侧边导航栏区域 -->
        <el-aside width="180px">
          <el-menu :default-active="isActive" background-color="#3d414d" text-color="#c9c9c9" active-text-color="#FFF" router @select="activePath" unique-opened>
            <div v-for="(menu, index1) in menuList" :key="index1">
              <el-menu-item v-if="menu.children.length == 0" :index="menu.requestUri">
                <i :class="menu.menuIcon"></i>
                <span slot="title">{{menu.name}}</span>
              </el-menu-item>
              <el-submenu v-if="menu.children.length > 0" :index="menu.requestUri">
                <template slot="title">
                  <i :class="menu.menuIcon"></i>
                  <span>{{menu.name}}</span>
                </template>
                <el-menu-item-group v-for="(child, index2) in menu.children" :key="index2">
                  <el-menu-item :index="child.requestUri">
                    <i :class="child.menuIcon"></i>
                    <span slot="title">{{child.name}}</span>
                  </el-menu-item>
                </el-menu-item-group>
              </el-submenu>
            </div>

          </el-menu>
        </el-aside>
        <!-- 主体内容区域 -->
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
    <!-- 修改密码对话框 -->
    <el-dialog title="修改密码" :visible.sync="pwDialogVisible" width="30%">
      <el-form ref="pwFormRef" :model="pwForm" :rules="pwRules" label-width="80px">
        <el-form-item label="原密码" prop="password">
          <el-input show-password placeholder="请输入原密码" v-model="pwForm.password"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input show-password placeholder="请输入新密码" v-model="pwForm.password1"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input show-password placeholder="请再次输入新密码" v-model="pwForm.password2"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="pwDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editPassword">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 修改个人信息对话框 -->
    <el-dialog title="修改个人信息" :visible.sync="infoDialogVisible" width="30%">
      <el-form :model="infoForm" label-width="40px">
        <el-form-item label="昵称">
          <el-input placeholder="请输入昵称" v-model="infoForm.nickname"></el-input>
        </el-form-item>
        <el-form-item label="号码">
          <el-input placeholder="请输入号码" v-model="infoForm.cellphone"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="infoDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { baseName } from '@/base.js'
import { logout, userInfo, password, menuQuery } from '@/API/login'
import Cookies from 'js-cookie'
export default {
  name: 'home',
  data() {
    return {
      baseName: baseName,
      // 被选中的侧边栏菜单
      isActive: '/welcome',
      // 修改密码对话框是否显示
      pwDialogVisible: false,
      // 修改密码表单数据
      pwForm: {
        password: '',
        password1: '',
        password2: ''
      },
      // 修改密码表单验证规则
      pwRules: {
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }, {
          min: 6,
          max: 16,
          message: '长度在 6 到 16 个字符',
          trigger: 'blur'
        }]
      },
      // 修改个人信息对话框是否显示
      infoDialogVisible: false,
      // 修改个人信息表单数据
      infoForm: {
        nickname: '',
        cellphone: ''
      },
      menuList: []
    }
  },
  mounted() {
    // if (window.sessionStorage.getItem('isActive') !== null) {
    //   this.isActive = window.sessionStorage.getItem('isActive')
    // }
    this.isActive = this.$route.path
  },
  created() {
    this.queryMenu()
  },
  methods: {
    activePath(index) {
      this.isActive = index
    },
    // 点击退出登录触发
    logout() {
      this.$confirm('确定要执行注销操作吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        // 销毁token,实现退出功能
        const {
          data: res
        } = await logout()
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success(res.message)
        // window.sessionStorage.clear()
        Cookies.remove('token')
        // 退出后重定向登录页面
        this.$router.push('/login')
      })
    },
    // 修改密码
    editPassword() {
      this.$refs.pwFormRef.validate(async valid => {
        if (!valid) return
        if (this.pwForm.password1 !== this.pwForm.password2) {
          this.pwForm = {}
          return this.$message.error('两次输入的密码不一致,请重新输入')
        }
        const {
          data: res
        } = await password(this.pwForm)
        this.$refs.pwFormRef.resetFields()
        if (res.code !== 200) return this.$message.error(res.message)
        this.$message.success('修改密码成功,请重新登录')
        // window.sessionStorage.clear()
        Cookies.remove('token')
        this.$router.push('/login')
        this.pwDialogVisible = false
      })
    },
    // 修改个人信息
    editInfo() {
      // this.infoForm.nickname = window.sessionStorage.getItem('nickname')
      // this.infoForm.cellphone = window.sessionStorage.getItem('cellphone')
      this.infoForm.nickname = Cookies.get('nickname')
      this.infoForm.cellphone = Cookies.get('cellphone')
      this.infoDialogVisible = true
    },
    // 提交修改个人信息
    async submit() {
      const {
        data: res
      } = await userInfo(this.infoForm)
      if (res.code !== 200) return this.$message.error(res.message)
      // window.sessionStorage.setItem('nickname', this.infoForm.nickname)
      // window.sessionStorage.setItem('cellphone', this.infoForm.cellphone)
      Cookies.set('nickname', this.infoForm.nickname)
      Cookies.set('cellphone', this.infoForm.cellphone)
      this.infoDialogVisible = false
      this.$message.success(res.message)
    },
    // 获取菜单
    async queryMenu() {
      const { data: res } = await menuQuery()
      if (res.code !== 200) return this.$message.error(res.message)
      this.menuList = res.data
      // console.log(this.menuList)
    }
  }
}
</script>
<style lang="less" scoped>
  .home {
    height: 100%;

    .el-container {
      height: 100%;

      .el-header {
        background-color: #262932;

        .title {
          float: left;
          font-size: 24px;
          font-weight: 700;
          line-height: 80px;
          color: #e8e8e8;
        }

        .menu {
          float: right;
          margin: 24px 0;

          .el-button,
          .el-dropdown{
            margin: 0 20px 0 0;
          }
        }
      }

      .el-aside {
        .el-menu {
          height: 100%;
          border: none;
        }
      }

      .el-main {
        padding: 20px;
      }
    }
  }
.el-submenu .el-menu-item {
  min-width: auto;
}
</style>
